export function normaliseCriterionId(num) {
  return num.replace(/\./g, "").toLowerCase();
}
